angular.module('impactx.approval').controller('ApprovalDetailCtrl', ['$scope', '$mdDialog', '$mdToast', 'dataGen',
    'BackService', 'ToastService', '$q','OpenGovernmentDataService', 'ToolbarService', '$redirect', 'backRoute',
    'TranslationService', 'WarningService', 'SubsequentPurchaseOrderDataService', '$route', ApprovalDetailCtrl]);

function ApprovalDetailCtrl($scope, $mdDialog, $mdToast, dataGen, BackService, ToastService, $q,
                            OpenGovernmentDataService, ToolbarService, $redirect, backRoute,
                            TranslationService, WarningService, SubsequentPurchaseOrderDataService, $route) {
    var ctrl = this;
    this.clearSelection = function()
    {
        $scope.selectedItems = [];
        $scope.selectedContractHeader = [];
    };

    this.back = function() {
        if (backRoute) {
            $redirect.redirectTo(null, backRoute);
        }
        else {
            BackService.back();
        }
    };

    $scope.clearItemSelection = function() {
        var idx;

        for(idx = 0; idx < $scope.selectedItems.length; idx++) {
            $scope.selectedItems[idx].selected = false;
        }

        $scope.selectedItems = [];
    };

    $scope.showItemComments = {value: false};
    $scope.showSupplierComments = {value: false};
    $scope.showComments = {value: false};
    $scope.showItemControl = {value: false};
    $scope.showSupplierControl = {value: false};
    $scope.showControl = {value: false};
    ctrl.clearSelection();
    $scope.selectedDeniedItems = [];
    $scope.showPostToast = function(message) {
        $mdToast.show(
            $mdToast.simple()
                .textContent(message)
                .position("bottom right")
                .hideDelay(10000)
        );
    };
    function DialogController($scope, $mdDialog) {
        $scope.hide = function() {
            $mdDialog.hide();
        };
        $scope.cancel = function() {
            $mdDialog.cancel();
        };
        $scope.answer = function(answer) {
            $mdDialog.hide(answer);
        };
    }


    $scope.viewAll = function() {
        return $scope.callViewEntryPoint($scope.getDataForHeaderAction());
    };

    $scope.approveRemaining = function(ev) {
        return WarningService.showWarningDialog($scope.approveAll, ev, TranslationService.get("warning"), $scope.trns.approveRemaining,
            $scope.trns.abort, [$scope.trns.warningInvalidItems], $scope.data.basket);
    };

    $scope.approveRemainingCSC = function(ev) {
        return WarningService.showWarningDialog($scope.approveCSC, ev, TranslationService.get("warning"), $scope.trns.approveRemaining,
            $scope.trns.abort, [$scope.trns.warningInvalidItems], $scope.data.basket);
    };

    $scope.approveAll = function(ev) {
        return $scope.callApproveEntryPoint($scope.getDataForHeaderAction(), function() {
            ctrl.back();
        }, ev);
    };
    $scope.denyAll = function(ev) {
        var allPositions = [];
        var data = $scope.getDataForHeaderAction();

        angular.forEach($scope.data.approval.contracts, function(contract) {
            allPositions = allPositions.concat(contract.items);
        });
        return $scope.callDenyEntryPoint(data, allPositions, $scope.showApprovalStopOrDenyDialog, function() {
            ctrl.back();
        }, ev);
    };
    $scope.stopAll = function(event) {
        var allPositions = [];

        angular.forEach($scope.data.approval.contracts, function(contract) {
            allPositions = allPositions.concat(contract.items);
        });
        return $scope.callStopEntryPoint($scope.getDataForHeaderAction(), function() {
        }, event, allPositions);
    };
    $scope.delegateBackAll = function() {
        return $scope.callDelegateBackEntryPoint($scope.getDataForHeaderAction(), function() {
            ctrl.back();
        });
    };
    $scope.delegateAll = function(ev) {
        var result = checkOGD();
        return handleOGDDialogs(ev, result).then(function () {
            var selectionData = $scope.getDataForHeaderAction();
            return $mdDialog.show({
                controller: 'DelegationUserController',
                templateUrl: 'modules/approval/templates/delegationuser.tmpl.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                locals: {
                    selectionData: selectionData,
                    entryPoint: $scope.getDelegationUserEntryPoint()
                }
            }).then(function (answer) {
                if (answer !== false) {
                    var data = $scope.getDataForHeaderAction();
                    data.delegationUserId = answer.id;
                    return $scope.callDelegateEntryPoint(data, function () {
                        ctrl.back();
                    })
                }
            });
        });
    };
    $scope.delegateItems = function(ev) {
        var result = checkOGD();
        return handleOGDDialogs(ev, result).then(function () {
            var selectionData = $scope.getDataForItemAction();
            return $mdDialog.show({
                controller: "DelegationUserController",
                templateUrl: 'modules/approval/templates/delegationuser.tmpl.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                locals: {
                    selectionData: selectionData,
                    entryPoint: $scope.getDelegationUserEntryPoint()
                }
            }).then(function (answer) {
                if (answer !== false) {
                    var data = $scope.getDataForItemAction();
                    data.delegationUserId = answer.id;
                    return $scope.callDelegateEntryPoint(data)
                }
            });
        });
    };
    
    $scope.getDelegationUserEntryPoint = function() {
        return "/approval/delegationuser";
    };

    $scope.delegateBackItems = function() {
        return $scope.callDelegateBackEntryPoint($scope.getDataForItemAction());
    };
    $scope.approveItems = function(event) {
        return $scope.callApproveEntryPoint($scope.getDataForItemAction(), angular.noop, event);
    };
    $scope.denyItems = function(event) {
        return $scope.callDenyEntryPoint($scope.getDataForItemAction(), $scope.selectedItems, $scope.showApprovalStopOrDenyDialog, null, event);
    };
    $scope.viewCSC = function(csc_id) {
        csc_id = csc_id || $scope.selectedContractHeader[0].id;
        return $scope.callViewEntryPoint($scope.getDataForCSCAction(csc_id, $scope.selectedContractHeader[0].supplierHeaderId));
    };
    $scope.delegateBackCSC = function(ev, csc_id) {
        csc_id = csc_id || $scope.selectedContractHeader[0].id;
        return $scope.callDelegateBackEntryPoint($scope.getDataForCSCAction(csc_id, $scope.selectedContractHeader[0].supplierHeaderId));
    };
    $scope.delegateCSC = function(ev, csc_id) {
        var result = checkOGD();
        return handleOGDDialogs(ev, result).then(function () {
            csc_id = csc_id || $scope.selectedContractHeader[0].id;
            var selectionData = $scope.getDataForCSCAction(csc_id, $scope.selectedContractHeader[0].supplierHeaderId);
            return $mdDialog.show({
                controller: "DelegationUserController",
                templateUrl: 'modules/approval/templates/delegationuser.tmpl.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                locals: {
                    selectionData: selectionData,
                    entryPoint: $scope.getDelegationUserEntryPoint()
                }
            }).then(function (answer) {
                if (answer !== false) {
                    var data = selectionData;
                    data.delegationUserId = answer.id;
                    return $scope.callDelegateEntryPoint(data);
                }
            });
        });
    };
    $scope.approveCSC = function(event) {
        return $scope.callApproveEntryPoint($scope.getDataForCSCAction($scope.selectedContractHeader[0].id, $scope.selectedContractHeader[0].supplierHeaderId), angular.noop, event);
    };

    $scope.denyCSC = function(contract, event) {
        var csc_id = $scope.selectedContractHeader[0].id;
        contract = contract || $scope.selectedContractHeader[0];
        return $scope.callDenyEntryPoint($scope.getDataForCSCAction(csc_id, $scope.selectedContractHeader[0].supplierHeaderId), contract.items,
            $scope.showApprovalStopOrDenyDialog, null, event, contract);
    };
    $scope.viewItems = function() {
        return $scope.callViewEntryPoint($scope.getDataForItemAction());
    };
    $scope.editItem = function(ev) {
        return $scope.callEditEntryPoint(ev);
    };
    $scope.recallDelegate = function(item) {
        return $scope.callRecallDelegate($scope.getDataForItemActionOneItem(item));
    };
    $scope.recallEscalate = function(item) {
        return $scope.callRecallEscalate($scope.getDataForItemActionOneItem(item));
    };
    $scope.callDelegateBackEntryPoint = function(data, callback) {
        return $scope.saveData(null, true).then(function () {
            return dataGen.post($scope, data, "/approval/delegateback", function(data) {
                $scope.handleControlDataForChips();
                $scope.showPostToast($scope.trns.saveSuccess);
                ctrl.clearSelection();
                if (callback)
                {
                    callback();
                }
            }).finally(ctrl.clearSelection);
        });
    };

    $scope.callApproveEntryPoint = function(data, callback, event) {
        var result = checkOGD();
        return handleOGDDialogs(event, result).then(function () {
            return $scope.saveData(null, true, true).then(function () {
                return dataGen.post($scope, data, "/approval/approve", function (data) {
                    $scope.handleControlDataForChips();
                    $scope.showPostToast($scope.trns.saveSuccess);
                    ctrl.clearSelection();
                    if (callback) {
                        callback();
                    }
                }).finally(ctrl.clearSelection);
            });
        });
    };

    $scope.callDenyEntryPoint = function(data, positions, dialogFunction, callback, event, contract) {
        return $scope.saveData(null, true).then(function () {
            return dialogFunction(event, positions, true).then(function(response) {
                data.newComment = response;
                return dataGen.post($scope, data, "/approval/deny", function() {
                    $scope.handleControlDataForChips();
                    $scope.showPostToast($scope.trns.saveSuccess);
                    ctrl.clearSelection();
                    if (callback)
                    {
                        callback();
                    }
                }).finally(ctrl.clearSelection);
            });
        });
    };
    $scope.callRecallDelegate = function(data) {
        return $scope.saveData(null, true).then(function () {
            return dataGen.post($scope, data, "/approval/recalldelegate", function (data) {
                $scope.handleControlDataForChips();
                $scope.showPostToast($scope.trns.saveSuccess);
            })
        });
    };
    $scope.callRecallEscalate = function(data) {
        return $scope.saveData(null, true).then(function () {
            return dataGen.post($scope, data, "/approval/recallescalate", function(data) {
                $scope.handleControlDataForChips();
                $scope.showPostToast($scope.trns.saveSuccess);
            })
        });
    };
    $scope.callViewEntryPoint = function(data) {
        const dataObj = {
            data: data
        };
        return $scope.saveData(null, true).then(function () {
            return dataGen.postAsForm($scope, dataObj, "/approval/approvalview").then(function (data) {
                $scope.handleControlDataForChips();
                $scope.showPostToast($scope.trns.saveSuccess);
            }).finally(ctrl.clearSelection);
        });
    };
    $scope.callStopEntryPoint = function(data, callback, event, positions) {
        return $scope.saveData(null, true).then(function () {
            return $scope.showApprovalStopOrDenyDialog(event, positions, false).then(function (response) {
                $scope.handleControlDataForChips();
                data.newComment = response;
                return dataGen.post($scope, data, "/approval/stop").then(function () {
                    $scope.showPostToast($scope.trns.saveSuccess);
                    if (callback) {
                        callback();
                    }
                    ctrl.back();
                })
            });
        });
    };

    $scope.showApprovalStopOrDenyDialog = function(event, positions, denial) {
        var allNotDeniedItems = [];
        var deniedItems = [];
        var approvalComments = {};
        var toDoItems = [];
        var doneItems = [];

        angular.copy($scope.data.approval.comments.approvalComments, approvalComments);
        angular.forEach($scope.data.approval.contracts, function(contractTemp) {
            allNotDeniedItems = allNotDeniedItems.concat(contractTemp.items);
            deniedItems = deniedItems.concat(contractTemp.deniedItems);
        });

        angular.forEach(allNotDeniedItems, function(item) {
            angular.forEach(positions, function(position) {
                if(position.id == item.id) {
                    item.isActionMarked = ((denial && !position.isDone) || (!denial && !position.isDenied));
                }
            });
            if (item.isDone)
            {
                doneItems.push(item);
            }
            else
            {
                toDoItems.push(item);
            }
        });

        return $mdDialog.show({
            controller: "ApprovalDetailStopOrDenyDialogCtrl",
            controllerAs: "approvalDetailStopOrDenyDialogCtrl",
            templateUrl: "modules/approval/templates/approvaldetailstopordenydialog.tmpl.html",
            parent: angular.element(document.body),
            targetEvent: event,
            clickOutsideToClose: true,
            locals: {
                doneItems: doneItems,
                toDoItems: toDoItems,
                deniedItems: deniedItems,
                title: $scope.trns.approvalComments,
                message: $scope.trns.details,
                approvalComments: approvalComments,
                trns: {
                    doneItems: $scope.trns.doneItems,
                    openItems: $scope.trns.openItems,
                    deniedItems: $scope.trns.deniedItems
                }
            }
        })
    };

    $scope.callDelegateEntryPoint = function(data, callback) {
        return $scope.saveData(null, true).then(function () {
            return dataGen.post($scope, data, "/approval/delegate", function (data) {
                $scope.handleControlDataForChips();
                $scope.showPostToast($scope.trns.saveSuccess);
                ctrl.clearSelection();
                if (callback) {
                    callback();
                }
            })
        }).finally(ctrl.clearSelection);;
    };

    $scope.canView = function(items) {
        for(var i = 0; i < items.length; i++) {
            if(!items[i].viewAllowed) {
                return false;
            }
        }
        return true;
    };

    $scope.canEdit = function(items) {
        if(items.length === 1) {
            return items[0].allowModify;
        }
        return false;
    };

    $scope.canReplace = function(items) {
        if(items.length === 1) {
            return items[0].allowReplacement && !items[0].isCancelled;
        }
        return false;
    };

    $scope.canReplaceOCI = function(items) {
        if(items.length === 1) {
            return items[0].allowReplacement && items[0].allowOCIReplacement && !items[0].isCancelled;
        }
        return false;
    };

    $scope.itemsAreNew = function(items) {
        for(var i = 0; i < items.length; i++) {
            if(!items[i].isNew) {
                return false;
            }
        }
        return true;
    };

    $scope.itemsAreInvalid = function(items) {
        for(var i = 0; i < items.length; i++) {
            if(items[i].isInvalid) {
                return true;
            }
        }
        return false;
    };

    $scope.itemsContainsAllDiscounts = function(items) {
        for(var i = 0; i < items.length; i++) {
            if(items[i].containsAllDiscounts) {
                return true;
            }
        }
        return false;
    };

    $scope.isNotDone = function(items) {
        for(var i = 0; i < items.length; i++) {
            if(items[i].isDone || items[i].isCancelled || items[i].isDenied) {
                return false;
            }
        }
        return true;
    };

    $scope.canDelegateBack = function(items) {
        for(var i = 0; i < items.length; i++) {
            if(!items[i].isDelegation && !items[i].isEscalation) {
                return false;
            }
        }
        return true;
    };

    $scope.selectSupplier = function(contractHeader) {
        $scope.showSupplierComments.value = false;
        $scope.showSupplierControl.value = false;
        for(var i = 0; i < $scope.selectedItems.length; i++) {
            $scope.selectedItems[i].selected = false;
        }
        $scope.selectedItems = [];
        if($scope.selectedContractHeader[0] == contractHeader) {
            $scope.selectedContractHeader = [];
        }
        else {
            $scope.selectedContractHeader[0] = contractHeader;
        }
    };

    $scope.toggleItemComments = function() {
        $scope.showItemComments.value = !$scope.showItemComments.value;
    };
    $scope.toggleSupplierComments = function() {
        $scope.showSupplierComments.value = !$scope.showSupplierComments.value;
    };
    $scope.toggleComments = function() {
        $scope.showComments.value = !$scope.showComments.value;
    };
    $scope.toggleItemControl = function() {
        $scope.showItemControl.value = !$scope.showItemControl.value;
    };
    $scope.toggleSupplierControl = function() {
        $scope.showSupplierControl.value = !$scope.showSupplierControl.value;
    };
    $scope.toggleControl = function() {
        $scope.showControl.value = !$scope.showControl.value;
    };



    /**
     * Determines if the label should be approveAll or approveRemaining.
     * @param contract the selected contract (optional)
     * @returns {string} the label
     */
    $scope.getApproveLabel = function(contract) {
        contract = contract || $scope.selectedContractHeader[0];
        return hasDeniedOrDoneItems(contract) ? $scope.trns.approveRemaining : $scope.trns.approveAll;
    };

    /**
     * Determines if the label should be denyAll or denyRemaining.
     * @param contract the selected contract (optional)
     * @returns {string} the label
     */
    $scope.getDenyLabel = function(contract) {
        contract = contract || $scope.selectedContractHeader[0];
        return hasDeniedOrDoneItems(contract) ? $scope.trns.denyRemaining : $scope.trns.denyAll;
    };

    /**
     * Checks if the approval data has denied or done items.
     * @param contract the selected contract (optional)
     * @returns {boolean}
     */
    function hasDeniedOrDoneItems(contract) {
        contract = contract || $scope.selectedContractHeader[0];
        if (contract)
        {
            return contract.hasDeniedOrDoneItems;
        }
        else
        {
            return $scope.data.approval.hasDeniedOrDoneItems;
        }
    }

    $scope.saveData = function(event, noDirectCall, approve) {
        if (!noDirectCall || approve)
        {
            return dataGen.postAsForm({}, {
                data: $scope.data.approval,
                headerTable: $scope.getHeaderTable()
            }, "/approval/save").then(function () {
                if(!approve){
                    ctrl.back();
                }
                ToastService.openStandardToast($scope.trns.saveSuccess);
            });
        }
        var defer = $q.defer();
        if (!approve && !$scope.dialogData.$pristine && (($scope.data.approval.canEditControl && $scope.controlHasBeenChanged())
            || ($scope.data.approval.canEditMaterialGroup && $scope.materialGroupHasBeenChanged()))) {
            $scope.saveDataDialog(approve).then(function(answer) {
                if (!answer) {
                    dataGen.postAsForm({}, {
                        data: $scope.data.approval,
                        headerTable: $scope.getHeaderTable()
                    }, "/approval/save").then(
                        function (data) {
                            defer.resolve();
                        }, function () {
                            defer.reject()
                        })
                }
                else
                {
                    defer.resolve();
                }
            }, function () {
                defer.reject()
            })
        }
        else {
            defer.resolve();
        }
        return defer.promise;
    };

    $scope.saveDataDialog = function(approve) {
        var defer = $q.defer();
        $mdDialog.show({
            controller: "RedirectAndSaveCtrl",
            controllerAs: "redirectAndSaveCtrl",
            templateUrl: "shared/redirectandsavedialog/templates/redirectandsave.tmpl.html",
            parent: angular.element(document.body),
            targetEvent: event,
            clickOutsideToClose: false,
            locals: {
                saveLabel: $scope.trns.save,
                noSaveLabel: $scope.trns.noSave,
                message: $scope.trns.saveDataMessage,
                abortLabel: $scope.trns.abort,
                mustSave: approve && $scope.materialGroupWasNotSetAndIsRequired()
            }
        }).then(function ()
        {
            defer.resolve();
        }, function (answer)
        {
            if (answer != "abort")
            {
                defer.resolve(answer);
            }
            else
            {
                defer.reject();
            }
        });
        return defer.promise;
    };

    $scope.handleControlDataForChips = function () {
        handleControlDataForChips($scope.data.approval.control);
        for(var i = 0; i < $scope.data.approval.contracts.length; i++) {
            var contract = $scope.data.approval.contracts[i];
            handleControlDataForChips(contract.control);
            for(var j = 0; j < contract.items.length; j++) {
                handleControlDataForChips(contract.items[j].control);
            }
        }
        $scope.oldApprovalData = JSON.parse(JSON.stringify($scope.data));
    };

    $scope.controlHasBeenChanged = function () {
        var controlHasBeenChanged = false;
        controlHasBeenChanged = controlHasBeenChanged || $scope.attHasChanged($scope.oldApprovalData.approval.aat, $scope.data.approval.aat);
        controlHasBeenChanged = controlHasBeenChanged || $scope.controlHasBeenChangedForOne($scope.oldApprovalData.approval.control, $scope.data.approval.control);
        controlHasBeenChanged = controlHasBeenChanged || $scope.controlHasBeenChangedForOne($scope.data.approval.control, $scope.oldApprovalData.approval.control);
        for(var i = 0; i < $scope.data.approval.contracts.length; i++) {
            var contract = $scope.data.approval.contracts[i];
            var contractOld = $scope.oldApprovalData.approval.contracts[i];
            controlHasBeenChanged = controlHasBeenChanged || $scope.attHasChanged(contractOld.aat, contract.aat);
            controlHasBeenChanged = controlHasBeenChanged || $scope.controlHasBeenChangedForOne(contractOld.control, contract.control);
            controlHasBeenChanged = controlHasBeenChanged || $scope.controlHasBeenChangedForOne(contract.control, contractOld.control);
            for(var j = 0; j < contract.items.length; j++) {
                controlHasBeenChanged = controlHasBeenChanged || $scope.attHasChanged(contractOld.items[j].aat, contract.items[j].aat);
                controlHasBeenChanged = controlHasBeenChanged || $scope.controlHasBeenChangedForOne(contractOld.items[j].control, contract.items[j].control);
                controlHasBeenChanged = controlHasBeenChanged || $scope.controlHasBeenChangedForOne(contract.items[j].control, contractOld.items[j].control);
            }
        }
        return controlHasBeenChanged;
    };
    
    $scope.attHasChanged = function(firstAAT, secondAAT) {
        if(!!firstAAT !== !!secondAAT){
            return true
        }
        if(!!firstAAT.selected !== !!secondAAT.selected){
            return true;
        }
        if(!firstAAT.selected){ // this also means secondAAT.selected is falsey
            return false;
        }
        return firstAAT.selected.id !== secondAAT.selected.id;
    };

    $scope.materialGroupWasNotSetAndIsRequired = function() {
        var materialGroupWasNotSetAndIsRequired = false;
        for(var i = 0; i < $scope.data.approval.contracts.length; i++) {
            var contractOld = $scope.oldApprovalData.approval.contracts[i];
            for(var j = 0; j < contractOld.items.length; j++) {
                if (contractOld.items[j].eClassMaterialGroupMapping)
                {
                    if (contractOld.items[j].eClassMaterialGroupMapping.showMust &&
                        (!contractOld.items[j].eClassMaterialGroupMapping.selected || !contractOld.items[j].eClassMaterialGroupMapping.selected.id))
                    {
                        materialGroupWasNotSetAndIsRequired = true;
                    }
                }
            }
        }
        return materialGroupWasNotSetAndIsRequired;
    };

    $scope.materialGroupHasBeenChanged = function () {
        var materialGroupHasBeenChanged = false;
        for(var i = 0; i < $scope.data.approval.contracts.length; i++) {
            var contract = $scope.data.approval.contracts[i];
            var contractOld = $scope.oldApprovalData.approval.contracts[i];
            for(var j = 0; j < contract.items.length; j++) {
                materialGroupHasBeenChanged = materialGroupHasBeenChanged ||
                    $scope.materialGroupHasBeenChangedForOne(contractOld.items[j].eClassMaterialGroupMapping,
                        contract.items[j].eClassMaterialGroupMapping);
            }
        }
        return materialGroupHasBeenChanged;
    };

    $scope.materialGroupHasBeenChangedForOne = function(firstObject, secondObject) {
       if (firstObject && secondObject) {
           if (firstObject.selected)
           {
               if (secondObject.selected)
               {
                   return firstObject.selected.id !== secondObject.selected.id;
               }
               else
               {
                   return firstObject.selected.id > 0;
               }
           }
           else
           {
               return secondObject.selected && secondObject.selected.id > 0;
           }
       }
       return false;
    };

    $scope.controlHasBeenChangedForOne = function(firstObject, secondObject) {
        if (firstObject) {
            if (firstObject.ctu) {
                for (var ctuDist = 0; ctuDist < firstObject.ctu.set.length; ctuDist++) {
                    var firstCtu = firstObject.ctu.set[ctuDist];
                    var secondCtu = secondObject.ctu.set[ctuDist];
                    if (!secondCtu || firstCtu.id !== secondCtu.id || firstCtu.factor !== secondCtu.factor) {
                        return true;
                    }
                }
            }
            if (firstObject.ctt) {
                for (var cttDist = 0; cttDist < firstObject.ctt.set.length; cttDist++) {
                    var firstCtt = firstObject.ctt.set[cttDist];
                    var secondCtt = secondObject.ctt.set[cttDist];
                    if (!secondCtt || firstCtt.id !== secondCtt.id || firstCtt.factor !== secondCtt.factor) {
                        return true;
                    }
                }
            }
            if (firstObject.prj) {
                for (var prjDist = 0; prjDist < firstObject.prj.set.length; prjDist++) {
                    var firstPrj = firstObject.prj.set[prjDist];
                    var secondPrj = secondObject.prj.set[prjDist];
                    if (!secondPrj || firstPrj.id !== secondPrj.id || firstPrj.factor !== secondPrj.factor) {
                        return true;
                    }
                }
            }
            if (firstObject.ctrlA) {
                for (var ctrlADist = 0; ctrlADist < firstObject.ctrlA.set.length; ctrlADist++) {
                    var firstCtrlA = firstObject.ctrlA.set[ctrlADist];
                    var secondCtrlA = secondObject.ctrlA.set[ctrlADist];
                    if (!secondCtrlA || firstCtrlA.id !== secondCtrlA.id || firstCtrlA.factor !== secondCtrlA.factor) {
                        return true;
                    }
                }
            }
            if (firstObject.ctrlB) {
                for (var ctrlBDist = 0; ctrlBDist < firstObject.ctrlB.set.length; ctrlBDist++) {
                    var firstCtrlB = firstObject.ctrlB.set[ctrlBDist];
                    var secondCtrlB = secondObject.ctrlB.set[ctrlBDist];
                    if (!secondCtrlB || firstCtrlB.id !== secondCtrlB.id || firstCtrlB.factor !== secondCtrlB.factor) {
                        return true;
                    }
                }
            }
            if (firstObject.ctrlC) {
                for (var ctrlCDist = 0; ctrlCDist < firstObject.ctrlC.set.length; ctrlCDist++) {
                    var firstCtrlC = firstObject.ctrlC.set[ctrlCDist];
                    var secondCtrlC = secondObject.ctrlC.set[ctrlCDist];
                    if (!secondCtrlC || firstCtrlC.id !== secondCtrlC.id || firstCtrlC.factor !== secondCtrlC.factor) {
                        return true;
                    }
                }
            }
            if (firstObject.ctrlD) {
                for (var ctrlDDist = 0; ctrlDDist < firstObject.ctrlD.set.length; ctrlDDist++) {
                    var firstCtrlD = firstObject.ctrlD.set[ctrlDDist];
                    var secondCtrlD = secondObject.ctrlD.set[ctrlDDist];
                    if (!secondCtrlD || firstCtrlD.id !== secondCtrlD.id || firstCtrlD.factor !== secondCtrlD.factor) {
                        return true;
                    }
                }
            }
            if (firstObject.crd) {
                for (var crdDist = 0; crdDist < firstObject.crd.set.length; crdDist++) {
                    var firstCrd = firstObject.crd.set[crdDist];
                    var secondCrd = secondObject.crd.set[crdDist];
                    if (!secondCrd || firstCrd.id !== secondCrd.id || firstCrd.factor !== secondCrd.factor) {
                        return true;
                    }
                }
            }
            if (firstObject.psp) {
                for (var pspDist = 0; pspDist < firstObject.psp.set.length; pspDist++) {
                    var firstPsp = firstObject.psp.set[pspDist];
                    var secondPsp = secondObject.psp.set[pspDist];
                    if (!secondPsp || firstPsp.id !== secondPsp.id || firstPsp.factor !== secondPsp.factor) {
                        return true;
                    }
                }
            }
            if (firstObject.asn) {
                for (var asnDist = 0; asnDist < firstObject.asn.set.length; asnDist++) {
                    var firstAsn = firstObject.asn.set[asnDist];
                    var secondAsn = secondObject.asn.set[asnDist];
                    if (!secondAsn || firstAsn.id !== secondAsn.id || firstAsn.factor !== secondAsn.factor) {
                        return true;
                    }
                }
            }
            if (firstObject.ino) {
                for (var inoDist = 0; inoDist < firstObject.ino.set.length; inoDist++) {
                    var firstIno = firstObject.ino.set[inoDist];
                    var secondIno = secondObject.ino.set[inoDist];
                    if (!secondIno || firstIno.id !== secondIno.id || firstIno.factor !== secondIno.factor) {
                        return true;
                    }
                }
            }
            if (firstObject.loc) {
                for (var locDist = 0; locDist < firstObject.loc.set.length; locDist++) {
                    var firstLoc = firstObject.loc.set[locDist];
                    var secondLoc = secondObject.loc.set[locDist];
                    if (!secondLoc || firstLoc.id !== secondLoc.id || firstLoc.factor !== secondLoc.factor) {
                        return true;
                    }
                }
            }
            if (firstObject.eko) {
                for (var ekoDist = 0; ekoDist < firstObject.eko.set.length; ekoDist++) {
                    var firstEko = firstObject.eko.set[ekoDist];
                    var secondEko = secondObject.eko.set[ekoDist];
                    if (!secondEko || firstEko.id !== secondEko.id || firstEko.factor !== secondEko.factor) {
                        return true;
                    }
                }
            }
            if (firstObject.ekg) {
                for (var ekgDist = 0; ekgDist < firstObject.ekg.set.length; ekgDist++) {
                    var firstEkg = firstObject.ekg.set[ekgDist];
                    var secondEkg = secondObject.ekg.set[ekgDist];
                    if (!secondEkg || firstEkg.id !== secondEkg.id || firstEkg.factor !== secondEkg.factor) {
                        return true;
                    }
                }
            }
            if (firstObject.act) {
                for (var actDist = 0; actDist < firstObject.act.set.length; actDist++) {
                    var firstAct = firstObject.act.set[actDist];
                    var secondAct = secondObject.act.set[actDist];
                    if (!secondAct || firstAct.id !== secondAct.id || firstAct.factor !== secondAct.factor) {
                        return true;
                    }
                }
            }
            if (firstObject.net) {
                for (var netDist = 0; netDist < firstObject.net.set.length; netDist++) {
                    var firstNet = firstObject.net.set[netDist];
                    var secondNet = secondObject.net.set[netDist];
                    if (!secondNet || firstNet.id !== secondNet.id || firstNet.factor !== secondNet.factor) {
                        return true;
                    }
                }
            }
        }
        return false;
    };

    $scope.formatAddressValue = function (value) {
        if(value) {
            return value.replace(/,\s/g, '<br/>')
        }
        return '';
    }
    
    var isNothingSelected = function() {
        return $scope.selectedItems.length == 0 && $scope.selectedContractHeader.length == 0;
    };
    
    var isContractSelected = function() {
        return $scope.selectedContractHeader.length > 0 && $scope.selectedItems.length == 0;
    };

    var isItemSelected = function() {
        return $scope.selectedContractHeader.length == 0 && $scope.selectedItems.length > 0;
    };

    var canEditControlOrMaterialGroup = function() {
        return $scope.data.approval.canEditControl || $scope.data.approval.canEditMaterialGroup;
    };

    var canEditData = function() {
        if (canEditControlOrMaterialGroup()) {
            return true;
        }
        else {
            for (var i = 0; i < $scope.data.approval.contracts.length; i++) {
                var contract = $scope.data.approval.contracts[i];
                if (contract.totalToDoItems > 0 && contract.individualOrderEMail) {
                    return true;
                }
            }
            return false;
        }
    };
    
    var canToggleCtrlHeader = function() {
        return isNothingSelected() && canEditControlOrMaterialGroup();
    };
    
    var canApproveAll = function() {
        return isNothingSelected() && $scope.data.approval.hasNewItems && $scope.data.approval.hasRightToApprove && !$scope.data.approval.isCancelledOrDone && !$scope.data.approval.hasInvalidItems;
    };

    var canApproveRemaining = function() {
        return isNothingSelected() && $scope.data.approval.hasNewItems && $scope.data.approval.hasRightToApprove && !$scope.data.approval.isCancelledOrDone && $scope.data.approval.hasInvalidItems && $scope.data.approval.hasNonInvalidItems;
    };

    var canDenyAll = function() {
        return isNothingSelected() && $scope.data.approval.hasNewItems && $scope.data.approval.hasRightToDeny && !$scope.data.approval.isCancelledOrDone;
    };
    
    var canStopAll = function() {
        return isNothingSelected() && $scope.data.approval.hasNewItems && $scope.data.approval.hasRightToStop;
    };
    
    var canDelegateBackAll = function(){
        return isNothingSelected() && $scope.data.approval.hasGlobalRightToDelegateBack
            && $scope.data.approval.canBeDelegated;
    };
    
    var canDelegateAll = function() {
        return isNothingSelected() && $scope.data.approval.hasRightToDelegate && $scope.data.approval.totalToDoItems > 0
            && !$scope.data.approval.isCancelledOrDone && $scope.data.approval.canBeDelegated;
    };

    var canViewAll = function() {
        return isNothingSelected() && $scope.data.approval.hasGlobalRightToView;
    };

    var canToggleCtrlContract = function() {
        return isContractSelected() && canEditControlOrMaterialGroup();
    };
    
    var canApproveContract = function(){
        return isContractSelected() && $scope.data.approval.hasRightToApprove && !$scope.selectedContractHeader[0].hasInvalidItems && $scope.selectedContractHeader[0].hasNewItems && !$scope.selectedContractHeader[0].isCancelledOrDone;
    };

    var canApproveRemainingContract = function(){
        return isContractSelected() && $scope.data.approval.hasRightToApprove && $scope.selectedContractHeader[0].hasInvalidItems && $scope.selectedContractHeader[0].hasNonInvalidItems && $scope.selectedContractHeader[0].hasNewItems && !$scope.selectedContractHeader[0].isCancelledOrDone;
    };
    
    var canDenyContract = function(){
        return isContractSelected() && $scope.data.approval.hasRightToDeny && $scope.selectedContractHeader[0].hasNewItems  && !$scope.selectedContractHeader[0].isCancelledOrDone;
    };
    
    var canDelegateBackContract = function(){
        return isContractSelected() && $scope.data.approval.hasRightToDelegateBack && $scope.selectedContractHeader[0].isDelegation  &&
            !$scope.selectedContractHeader[0].isCancelledOrDone && $scope.data.approval.canBeDelegated;
    };
    
    var canDelegateContract = function(){
        return isContractSelected() && $scope.data.approval.hasRightToDelegate && $scope.selectedContractHeader[0].totalToDoItems > 0  &&
        !$scope.selectedContractHeader[0].isCancelledOrDone && $scope.data.approval.canBeDelegated;
    };
    
    var canViewContract = function(){
        return isContractSelected() && $scope.selectedContractHeader[0].viewAllowed;
    };
    
    var canToggleCtrlItem = function(){
        return isItemSelected() && canEditControlOrMaterialGroup();
    };

    var canViewCateringData = function () {
        return isItemSelected() && $scope.selectedItems.length === 1 && $scope.selectedItems[0].isCatering;
    }
    
    var canApproveItem = function(){
        return isItemSelected() && $scope.data.approval.hasRightToApprove && !$scope.itemsAreInvalid($scope.selectedItems) && $scope.itemsAreNew($scope.selectedItems) && !$scope.itemsContainsAllDiscounts($scope.selectedItems);
    };

    var canDenyItem = function(){
        return isItemSelected() && $scope.data.approval.hasRightToDeny && $scope.itemsAreNew($scope.selectedItems) && !$scope.itemsContainsAllDiscounts($scope.selectedItems);
    };

    var canDelegateBackItem = function(){
        return isItemSelected() && $scope.data.approval.hasRightToDelegateBack && $scope.canDelegateBack($scope.selectedItems)
            && !$scope.itemsContainsAllDiscounts($scope.selectedItems) && $scope.data.approval.canBeDelegated;
    };

    var canDelegateItem = function(){
        return isItemSelected() && $scope.data.approval.hasRightToDelegate && $scope.isNotDone($scope.selectedItems)
            && !$scope.itemsContainsAllDiscounts($scope.selectedItems) && $scope.data.approval.canBeDelegated;
    };
    
    var canViewItem = function(){
        return isItemSelected() && $scope.canView($scope.selectedItems);
    };
    
    var canEditItem = function(){
        return isItemSelected() && $scope.canEdit($scope.selectedItems);
    };

    var canReplaceItem = function(){
        return isItemSelected() && $scope.canReplace($scope.selectedItems);
    };

    var canReplaceItemOCI = function(){
        return isItemSelected() && $scope.canReplaceOCI($scope.selectedItems);
    };

    var canModifyItem = function(){
        return $scope.selectedItems.length === 1 && $scope.selectedItems[0].showApprovalModifiedLink;
    };
    
    $scope.getClearLabel = function(){
        return $scope.selectedItems.length + " " + $scope.trns.selected;
    };

    var canEditAddressHeader = function () {
        return $scope.data.approval.canEditDeliveryAddress && isNothingSelected() && $scope.data.approval.hasAddress;
    };

    var canEditAddressCSC = function () {
        return isContractSelected() && $scope.selectedContractHeader[0].hasAddress && $scope.selectedContractHeader[0].canEditDeliveryAddress;
    };

    var canEditAddressItem = function () {
        return isItemSelected() && $scope.selectedItems.length === 1 && $scope.selectedItems[0].hasAddress && $scope.selectedItems[0].canEditDeliveryAddress;
    };

    $scope.showAddressChangeDialog = function (ev, transferredObject, id) {
        return $mdDialog.show({
            controller: "ApprovalChangeAddressController",
            templateUrl: 'modules/approval/templates/changeAddress.tmpl.html',
            parent: angular.element(document.body),
            targetEvent: ev,
            clickOutsideToClose: false,
            locals: {
                transferredObject: transferredObject,
                id: id
            }
        }).then(function () {
            $route.reload();
            ToastService.openStandardToast($scope.trns.saveSuccess);
        });
    };

    $scope.setButtons = function(){
        $scope.buttonDefinition = [
            // header buttons
            {label: TranslationService.get("back"), action: ctrl.back, type: 'dialogaction'},
            {label: $scope.trns.comments, action: $scope.toggleComments, type: 'dialogaction', condition: isNothingSelected},
            {label: $scope.trns.control, action: $scope.toggleControl, type: 'dialogaction', condition: canToggleCtrlHeader},
            {labelFunction: $scope.getApproveLabel, action: $scope.approveAll, type: 'validation', condition: canApproveAll, params:{
                    form: $scope.dialogData
                }},
            {label: $scope.trns.approveRemaining, action: $scope.approveRemaining, type: 'validation', condition: canApproveRemaining, params:{
                    form: $scope.dialogData
                }},
            {labelFunction: $scope.getDenyLabel, action: $scope.denyAll, type: 'dialogaction', condition: canDenyAll},
            {label: $scope.trns.stop, action: $scope.stopAll, type: 'dialogaction', condition: canStopAll},
            {label: $scope.trns.delegateBack, action: $scope.delegateBackAll, type: 'dialogaction', condition: canDelegateBackAll},
            {label: $scope.trns.delegate, action: $scope.delegateAll, type: 'validation', condition: canDelegateAll, params:{
                form: $scope.dialogData
            }},
            {label: $scope.trns.viewed, action: $scope.viewAll, type: 'dialogaction', condition: canViewAll},

            // contract buttons
            {label: $scope.trns.comments, action: $scope.toggleSupplierComments, type: 'dialogaction', condition: isContractSelected},
            {label: $scope.trns.control, action: $scope.toggleSupplierControl, type: 'dialogaction', condition: canToggleCtrlContract},
            {labelFunction: $scope.getApproveLabel, action: $scope.approveCSC, type: 'validation', condition: canApproveContract, params:{
                    form: $scope.dialogData
                }},
            {label: $scope.trns.approveRemaining, action: $scope.approveRemainingCSC, type: 'validation', condition: canApproveRemainingContract, params:{
                    form: $scope.dialogData
                }},
            {labelFunction: $scope.getDenyLabel, action: $scope.denyCSC, type: 'dialogaction', condition: canDenyContract},
            {label: $scope.trns.delegateBack, action: $scope.delegateBackCSC, type: 'dialogaction', condition: canDelegateBackContract},
            {label: $scope.trns.delegate, action: $scope.delegateCSC, type: 'validation', condition: canDelegateContract, params:{
                form: $scope.dialogData
            }},
            {label: $scope.trns.viewed, action: $scope.viewCSC, type: 'dialogaction', condition: canViewContract},

            // item buttons
            {labelFunction: $scope.getClearLabel, action: $scope.clearItemSelection, type: 'dialogaction', condition: isItemSelected, params: {
                    icon: 'mdi mdi-close ix-dialog-toolbar-tools'
                }},
            {label: $scope.trns.comments, action: $scope.toggleItemComments, type: 'dialogaction', condition: isItemSelected},
            {label: $scope.trns.control, action: $scope.toggleItemControl, type: 'dialogaction', condition: canToggleCtrlItem},
            {label: $scope.trns.viewCatering, action: $scope.showCateringDialog, type: 'dialogaction', condition: canViewCateringData},
            {label: $scope.trns.approve, action: $scope.approveItems, type: 'validation', condition: canApproveItem, params:{
                    form: $scope.dialogData
                }},
            {label: $scope.trns.deny, action: $scope.denyItems, type: 'dialogaction', condition: canDenyItem},
            {label: $scope.trns.delegateBack, action: $scope.delegateBackItems, type: 'dialogaction', condition: canDelegateBackItem},
            {label: $scope.trns.delegate, action: $scope.delegateItems, type: 'validation', condition: canDelegateItem, params:{
                form: $scope.dialogData
            }},
            {label: $scope.trns.viewed, action: $scope.viewItems, type: 'dialogaction', condition: canViewItem},
            {label: $scope.trns.edit, action: $scope.editItem, type: 'dialogaction', condition: canEditItem},
            {label: $scope.trns.replaceProduct, action: $scope.changeProduct, type: 'dialogaction', condition: canReplaceItem},
            {label: $scope.trns.replaceProductOCI, action: $scope.changeProductOCIFromDialog, type: 'dialogaction', condition: canReplaceItemOCI},
            {label: $scope.trns.approvalmodified, action: $scope.redirectToApprovalModified, type: 'dialogaction', condition: canModifyItem},
            {label: $scope.trns.editAddress, action: $scope.changeAddressHeader, type: 'dialogaction', condition: canEditAddressHeader},
            {label: $scope.trns.editAddress, action: $scope.changeAddressSupplierHeader, type: 'dialogaction', condition: canEditAddressCSC},
            {label: $scope.trns.editAddress, action: $scope.changeAddressItem, type: 'dialogaction', condition: canEditAddressItem},

            // general button
            {label: $scope.trns.save, action: $scope.saveData, type: 'dialogaction', condition: canEditData, params:{
                    form: $scope.dialogData
                }}
        ];
        ToolbarService.hideBackButton();
        ToolbarService.setButtons($scope.buttonDefinition);
    };

    $scope.openOpenGovernmentDialog = function (event, contractHeader) {
        OpenGovernmentDataService.openEditDialog(event, contractHeader.ogd.id, 0, contractHeader.supplierHeaderId, 0, false).then(function (answer) {
            if (answer) {
                contractHeader.ogd.id = answer.ogdId;
                contractHeader.ogd.summary = answer.summary;
            }
        });
    };

    $scope.openOpenGovernmentDialogReadOnly = function (event, contractHeader) {
        OpenGovernmentDataService.openReadOnlyDialog(event, contractHeader.ogd.id, contractHeader.contractName);
    };

    $scope.setOgdChanged = function(event, contractHeader) {
        if (!contractHeader.ogd.reportOGD.readOnly) {
            contractHeader.ogd.wasChanged = true;

            if (!contractHeader.ogd.id && !contractHeader.ogd.reportOGD.value) {
                $scope.openOpenGovernmentDialog(event, contractHeader);
            }
        }
    };

    function checkOGD() {
        var warningPRSIds = [];
        var confirmationPRSIds = [];
        var allPRSIds = [];
        var hasWarning = false;

        angular.forEach($scope.data.approval.contracts, function(contractHeader) {
            allPRSIds.push(contractHeader.supplierHeaderId);
            var reportOGD = impactX.isDefined(contractHeader, 'ogd.reportOGD');
            if (reportOGD) {
                if (reportOGD.secondValue && !reportOGD.value) {
                    hasWarning = true;
                    warningPRSIds.push(contractHeader.supplierHeaderId);
                }
                if (reportOGD.value) {
                    confirmationPRSIds.push(contractHeader.supplierHeaderId);
                }
            }
        });

        return {
            warningPRSIds: warningPRSIds,
            confirmationPRSIds: confirmationPRSIds,
            allPRSIds: allPRSIds,
            hasWarning: hasWarning,
        };
    }

    function handleOGDDialogs(event, result) {
        var defer = $q.defer();

        if (result.hasWarning) {
            return openOGDAgreementDialog(event, result.warningPRSIds, true).then(function () {
                if (result.confirmationPRSIds.length > 0) {
                    return openOGDAgreementDialog(event, result.confirmationPRSIds, false);
                }
                else {
                    defer.resolve();
                    return defer.promise;
                }
            });
        }
        else {
            if (result.confirmationPRSIds.length > 0) {
                return openOGDAgreementDialog(event, result.confirmationPRSIds, false);
            }
            else {
                defer.resolve();
                return defer.promise;
            }
        }
    }
    
    function openOGDAgreementDialog(event, prsIds, isWarning) {
        return OpenGovernmentDataService.openAgreementDialog(event, [], prsIds, [], isWarning);
    }
}


